import { apiClient } from '../../config/axios.config';
import { BASE_URL, BASE_LEAVE_URL } from '../apiConfig';

// Fetch WFH History
const fetchWfhHistory = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/wfh/enquiry`,
    payload,
  );
  return response;
};

// Apply for WFH
const applyWfh = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/wfh/apply`,
    payload,
  );
  return response;
};

export { fetchWfhHistory, applyWfh };
